import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import "../styles/MainLayout.css";

const MainLayout = ({
  children,
  pageTitle = "Dashboard",
  showSidebar = true,
  showTopBar = true,
  showFooter = true,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="main-layout">
      {/* Sidebar */}
      {showSidebar && (
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content Area */}
      <div className="layout-wrapper">
        {/* Top Bar */}
        {showTopBar && (
          <TopBar
            title={pageTitle}
            onMenuClick={() => setSidebarOpen(true)}
            showMenuButton={showSidebar}
          />
        )}

        {/* Main Content */}
        <main className={`${showSidebar ? 'layout-main' : 'layout-main-fullscreen'}`}>{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
